/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { FlowsState, EmptyConnection } from './models';
import { RootState } from '../models';

const namespaced: boolean = true;

export const state: FlowsState = {
  flows: [],
  selectedFlows: [],
  bricks: [],
  sortFlowsBy: 'name',
  flow: {
    id: '',
    name: '',
    owner: '',
    description: '',
    config: {
      id: '',
      name: '',
      bricks: [],
      connectionConfigId: '',
      mappedBuffers: {},
      constants: [],
      connections: [],
    },
    running: false,
    peer: [],
    previewimage: '',
    isDirty: false,
    workspaceId: '',
  },
  loading: false,
  port: {
    name: '',
    typeName: '',
    schema: '',
    JSONSchema: [],
    populatedJSON: {
      name: '',
      type: '',
      hideCheckBox: false,
    },
  },
  connections: [],
  connection: EmptyConnection,
  connectionSource: {
    name: '',
    type: '',
  },
  updateBrickLoading: false,
};

export const flow: Module<FlowsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
